require('./screen.css');
var Fragment = require('./fragment');

var paddingLeft = function (str, v) {
  var padding = v - str.length;
  for (var i = 0; i < padding; i++) {
    str = '0' + str;
  }
  return str;
};

var createBox = function () {
  var canvas = document.createElement('canvas');
  canvas.className = 'c-barrage__canvas';
  return canvas;
};

var Screen = function (options) {
  this.options = options;
  this.options.speed = options.speed || 100;
  this.options.rows = options.rows || 4;
  this.options.offsetTop = options.offsetTop || 20;
  this.options.offsetLeft = options.offsetLeft || 40;
  this.options.base = options.base || 375;
  this.options.per = options.per || 0.75;
  this.ratio = 2;
  this.init();
};

Screen.prototype = {
  init: function () {
    var createRow = function (value) {
      var result = [];
      for (var i = 0; i < value; i++) {
        result.push([]);
      }
      return result;
    };
    this.rows = createRow(this.options.rows);
    this.box = createBox();
    this.ctx = this.box.getContext("2d");
  },
  resize: function () {
    var canvas = this.box;
    var container = this.parentNode;
    canvas.width = container.offsetWidth * 2;
    canvas.height = container.offsetHeight * 2;
    canvas.style.width = container.offsetWidth + 'px';
    canvas.style.height = container.offsetHeight + 'px';

    this.boxHeight = this.box.offsetHeight;
    this.rowHeight = (this.boxHeight * this.options.per - this.options.offsetTop) / this.options.rows;
    this.dur = 1000 * window.innerWidth / this.options.speed;

    var ctx = this.ctx;
    ctx.shadowColor = "RGBA(0,0,0,1)";
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 4;
    ctx.shadowBlur = 8;
    this.resizeAllFragment();
  },
  isAllShow: function (fragment) {
    var left = fragment.options.begin.left;
    var now = fragment.getCurrentPosition().left;
    var size = fragment.options.size;
    if (left - now > size) {
      return true;
    } else {
      return false;
    }
  },
  isOut: function (fragment) {
    if (fragment.options.spend >= fragment.options.dur) {
      return true;
    } else {
      return false;
    }
  },
  render: function (fragment) {
    var size = {'14': 12, '18': 15, '22': 16}
    var ctx = this.ctx;
    var position = fragment.getCurrentPosition();
    if (fragment.options.color != '0') {
      ctx.fillStyle = '#' + paddingLeft(Number(fragment.options.color).toString(16), 6);
    } else {
      ctx.fillStyle = '#fff';
    }
    var fontSize = fragment.options.fontsize * window.innerWidth / this.options.base;
    ctx.font = fontSize * this.ratio + 'px SimSun';

    ctx.fillText(fragment.options.text, position.left, position.top);
  },
  remove: function (fragment) {
    var row = fragment.options.row;
    var index = this.rows[row].indexOf(fragment);

    if (index >= 0) {
      this.rows[row].splice(index, 1);
    }
  },
  removeAll: function () {
    for (var i = 0, iLen = this.rows.length; i < iLen; i++) {
      this.rows[i] = [];
    }
  },
  checkRow: function () {
    var result = [];
    var row;
    var fragment;
    for (var i = 0, iLen = this.rows.length; i < iLen; i++) {
      row = this.rows[i];
      if (row.length <= 0) {
        result.push(i);
      } else {
        fragment = row[row.length - 1];
        if (this.isAllShow(fragment)) {
          result.push(i);
        }
      }
    }
    if (result.length > 0) {
      return result[Math.floor(Math.random() * result.length)];

    } else {
      return null;
    }
  },
  resizeAllFragment: function () {
    var row;
    for (var i = 0, iLen = this.rows.length; i < iLen; i++) {
      row = this.rows[i];
      for (var j = 0, jLen = row.length; j < jLen; j++) {
        this.resizeFragment(row[j]);
      }
    }
  },
  resizeFragment: function (fragment) {
    var content = fragment.options.text;
    var row = fragment.options.row;
    var paddSize = fragment.options.paddSize;
    var top = this.options.offsetTop * this.ratio + (row + 0.5) * this.rowHeight * this.ratio;

    var fontSize = fragment.options.fontsize * window.innerWidth / this.options.base;
    this.ctx.font = fontSize * this.ratio + 'px SimSun';

    var size = this.ctx.measureText(content).width;
    var left = this.box.offsetWidth * 2 + paddSize;

    fragment.options.begin = {
      top: top,
      left: left
    };

    fragment.options.end = {
      top: top,
      left: 0 - size
    };

    fragment.options.size = size + paddSize;
    if (fragment.options.spend > 0) {
      fragment.options.spend = fragment.options.spend * this.dur / fragment.options.dur;
    }
    fragment.options.dur = this.dur;
  },
  createFragment: function (data, row) {
    // var top = this.options.offsetTop * this.ratio + (row + 0.5) * this.rowHeight * this.ratio;
    var paddSize = Math.floor(Math.random() * this.options.offsetLeft * this.ratio);
    // var left = this.box.offsetWidth * 2 + paddSize;
    // var size = this.ctx.measureText(data.content).width;
    var fragment = new Fragment({
          id: data.id,
          spend: 0,
          text: data.content,
          color: data.color,
          fontsize: data.fontsize,
          paddSize: paddSize,
          row: row
      });
    this.resizeFragment(fragment);
    this.rows[row].push(fragment);
    return fragment;

  },
  clear: function () {
    this.ctx.clearRect(0, 0, 10000, 10000);
  },
  hide: function () {
    this.box.style.visibility = 'hidden';
  },
  show: function () {
    this.box.style.visibility = 'visible';
  },
  renderTo: function (parentNode) {
    this.parentNode = parentNode;
    parentNode.appendChild(this.box);
    this.resize();
  }
};

module.exports = Screen;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.barrage.mobile/app/modules/canvas/screen.js